<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
import Hero from "@/components/media/Hero.vue";
export default {
  data() {
    return {
      opportunity: null,
      slides: [
        {
          img: "banner1.jpg",
        },
        {
          img: "banner2.jpg",
        },
        {
          img: "industria.jpg",
        },
      ],
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
    Hero
  },
};
</script>

<template>
  <div class="collection">
      <Hero
      title="VEM SER RESTOQUER"
      :slide="slides"
      height="77vh"
      :searchBox="true"
      style="margin-top:-4rem;margin-bottom:5rem"
    />
  </div>
</template>


<style lang="scss" scoped>
.collection {
    margin-top: 4rem;
}
h1 {
    font-size: 1.9rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
}
p {
    font-size: 1.2rem;
    color: #000;
    margin-top: 1rem;
     border-bottom: 2px solid theme-color(primary);
     padding-bottom: 2rem;
     margin-bottom: 1.5rem;
}
</style>